var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepositOb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4198_1922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 3.33325C15.2884 3.33325 12 6.62167 12 10.6666C12 14.7115 15.2884 17.9999 19.3333 17.9999C23.3782 17.9999 26.6667 14.7115 26.6667 10.6666C26.6667 6.62167 23.3782 3.33325 19.3333 3.33325ZM22.0042 8.11922H20.4603C20.6611 8.39706 20.8 8.72132 20.8772 9.06097H22.0042V10.1725L20.8772 10.1724C20.6302 11.3457 19.5804 12.2258 18.3299 12.2258H18.0674L21.0008 15.2054L19.3643 15.2055L16.6626 12.4729V11.0525H18.3299C18.932 11.0525 19.4415 10.682 19.6576 10.1725H16.6626V9.06089H19.6576C19.4415 8.536 18.932 8.18083 18.3299 8.18083L16.6626 8.18094V7.00764H21.9889V8.11921L22.0042 8.11922Z",
    fill: "#0EA5E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66669 35.9734H35.9993V37.3331H2.66669V35.9734ZM33.2482 15.2205L33.2382 15.2029L26.2258 15.1389L26.2179 15.1622C26.0855 15.5568 25.9095 15.9429 25.6955 16.3087L25.6684 16.3547L26.0932 16.3641C26.2258 16.3672 26.3437 16.4447 26.3861 16.5568L26.8899 17.8727C26.9234 17.9595 26.9074 18.0562 26.8477 18.1309C26.7884 18.2053 26.6917 18.2503 26.5889 18.2503H12.1147C12.0134 18.2503 11.917 18.2061 11.8571 18.1324C11.7974 18.0583 11.7806 17.9626 11.8128 17.8761L12.2781 16.6099C12.3206 16.4943 12.4404 16.4158 12.5759 16.4143L13.0309 16.4094L13.0027 16.3624C12.789 16.0053 12.6113 15.627 12.4752 15.2379L12.4672 15.2152L5.42791 15.2052L2.86934 19.6775H35.7973L33.2482 15.2205ZM13.4202 16.9747L12.8109 16.9813L12.5541 17.6804H14.0484L13.9942 17.6261C13.7919 17.4251 13.6028 17.2107 13.4313 16.989L13.4202 16.9747ZM24.6192 17.6801H26.1447L25.8576 16.9291L25.2908 16.9168L25.28 16.9314C25.0954 17.1754 24.8915 17.409 24.6741 17.6258L24.6192 17.6801ZM36 20.247V35.4032H2.66675V20.247H36Z",
    fill: "#0EA5E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4198_1922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositOb);
export default __webpack_public_path__ + "static/media/DepositOB.967c5bc77ab3c1d2a3a7c156c607674e.svg";
export { ForwardRef as ReactComponent };